import React, { useEffect, useState } from "react"
import BasicModal from "../GlobalComponents/BasicModal"
import { FormField } from "../GlobalComponents/Fields"
import Loader from "../GlobalComponents/Loader"
import "./index.css"
// import { ApiRequest } from "./services/api-request";
import { CONSULTANT, OPTOMETRIST, ORTHOPHIST, roleOptions } from "../../utils/constants"
import { showToast } from "../GlobalComponents/Toast"
import { matchIsValidColor, MuiColorInput } from "mui-color-input"
import { getRandomColor } from "../../utils/Helpers"
import { editUserData, saveUserData } from "../../services/userServices"

function UserRegistrationModal(props) {
  console.log("UserRegistrationModal", props)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    password: "",
    userName: "",
    role: "",
    profileUrl: "",
    ...props.formData,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [color, setColor] = React.useState("")
  const hideCredentials = ["GP", OPTOMETRIST, ORTHOPHIST].includes(formData.role)

  const emailValidateRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const passwordValidationText = (password) => {
    if (!password || password.length < 8) {
      return "Password (minimum 8 characters)"
    } else if (!/[A-Z]/.test(password)) {
      return "Password must include at least 1 uppercase letter"
    } else if (!/[a-z]/.test(password)) {
      return "Password must include at least 1 lowercase letter"
    } else if (!/[0-9]/.test(password)) {
      return "Password must include at least 1 number"
    } else if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) {
      return "Password must include at least 1 special character"
    } else {
      return "Password"
    }
  }

  // Handle input change for the form fields
  const handleChange = (e) => {
    console.log("eee", e, formData)
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const onChangeUserName = (e) => {
    let { name, value } = e.target
    value = (value.trim())?.toLowerCase()

    setFormData({
      ...formData,
      [name]: value,
    })
  }


  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  // Handle form submission (optional functionality)
  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Form submitted") // You can replace this with your submit logic
  }

  const validateForm = () => {
    const { firstName, lastName, password, userName, role, profileUrl } = formData
    const isValidFirstName = firstName?.length >= 3
    const isValidLastName = lastName?.length >= 3
    const isPasswordValid = passwordValidationText(password) === "Password"
    const isEmailValid = emailValidateRegex.test(userName)
    const isRoleValid = role.length > 0
    // const isProfileUrlValid = profileUrl.length > 0;
    const isProfileUrlValid = true

    let isValid = isValidFirstName && isValidLastName && isRoleValid
    if (!hideCredentials) {
      isValid = isValid && userName.length >= 3
      if (!props?.isEditing) {
        isValid = isValid && isPasswordValid
      }
    }
    return isValid
  }

  const [activeModal, setActiveModal] = useState("")

  function onCloseModal() {
    setActiveModal("")
  }

  let modalData = {
    onClose: onCloseModal,
  }

  if (activeModal === "GPModal") {
    modalData = {
      ...modalData,
      title: "GP Modal",
      show: true,
    }
  } else if (activeModal === "OptometristModal") {
    modalData = {
      ...modalData,
      title: "Optometrist Modal",
      show: true,
    }
  }

  const onSubmit = async () => {
    setIsLoading(true)

    if (props?.isEditing) {
      const data = await editUserData({ ...formData, color, email: formData.userName })
      console.log("saveUserError", data)

      if (data?.status !== "Success") {
        let message = data.error.message
        showToast("error", message)
      } else {
        showToast("info", "User Details Updated")
        props.onSubmit({ ...data, formData })
      }
    } else {
      const data = await saveUserData({ ...formData, color, email: formData.userName })
      console.log("saveUserError", data)

      if (data?.status !== "Success") {
        let message = data?.message || data?.error?.message
        showToast("error", message)
      } else {
        showToast("info", "User Saved")
        props.onSubmit({ ...data, formData })
      }
    }

    setIsLoading(false)
  }
  useEffect(() => {
    const randomColor = getRandomColor()
    if (props?.formData?.color) {
      setColor(props?.formData?.color)
    } else if (matchIsValidColor(randomColor)) {
      setColor(randomColor)
    }
  }, [])

  const data = { ...props, onSubmit: onSubmit, disableButton2: !validateForm() }

  return (
    <BasicModal {...data}>
      {isLoading && <Loader />}

      <div className="new-form-modal-body">
        <FormField
          type="dropdown"
          label="Role"
          name="role"
          value={formData.role}
          options={roleOptions}
          onChange={handleChange}
          errorMessage="Role is required"
          isError={formData.role.length === 0}
          disabled={formData.disabledRole}
        />

        <FormField
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          placeholder="Enter your First Name"
          errorMessage={`${formData.firstName?.length}/30 (minimum 3 characters)`}
          isError={formData?.firstName?.length < 3}
          maxLength={30}
        />

        <FormField
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          placeholder="Enter your Last Name"
          errorMessage={`${formData.lastName?.length}/30 (minimum 3 characters)`}
          isError={formData?.lastName?.length < 3}
          maxLength={30}
        />

        {!hideCredentials && (
          <>
            <FormField
              label="Username"
              name="userName"
              type="userName"
              value={formData.userName}
              onChange={onChangeUserName}
              placeholder="Enter your username"
              errorMessage="Please enter a valid username"
              isError={formData?.userName?.length < 3}
            />

            {!props?.isEditing && <FormField
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter Password"
              errorMessage={passwordValidationText(formData.password)}
              isError={passwordValidationText(formData.password) !== "Password"}
            />
            }
            {(formData.role === CONSULTANT) && <MuiColorInput
              value={color}
              onChange={(e) => setColor(e)}
              sx={{ cursor: "pointer" }}
              label="Pick Color"
              slotProps={{ input: { readOnly: true } }}
              size="small"
            />}
          </>
        )}

        {/* <FormField
                    label="Profile url"
                    name="profileUrl"
                    value={formData.profileUrl}
                    onChange={handleChange}
                    placeholder="Enter profile url"
                    // errorMessage="Profile URL is required"
                    // isError={formData.profileUrl.length === 0}
                /> */}
      </div>
    </BasicModal>
  )
}

export default UserRegistrationModal
